<!-- BR#206 Added email validation while signup -->
<template>
  <div v-if="visible" class="otp-modal">
    <div class="otp-container">
      <button class="close-btn" @click="closeModal">
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="24" height="24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
  </svg>
</button>
      
      <h2>{{$t("enter-otp")}}</h2>
      <p>{{$t("we-have-sent-an-otp-to-your-registered-email")}}</p>
      <input
        v-model="otp"
        type="text"
        :placeholder="$t('enter-otp')"
        maxlength="6"
        @input="filterNumeric"
        @keydown.enter.stop.prevent="verifyOtp"

      />

      <button type="button" class="verify-btn" @click="verifyOtp">{{$t("verify")}}</button>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";

export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      otp: "",
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.clearOtp(); // Clear OTP input when modal is shown
      }
    },
  },
  methods: {
    clearOtp() {
      this.otp = "";
    },
    filterNumeric(event) {
      this.otp = event.target.value.replace(/\D/g, ""); // Allow only numeric input
    },
    async verifyOtp() {

      if (this.otp.length !== 6) {
        this.$notify({
          group: "foo",
          text: `${this.$t("please-enter-a-valid-6-digit-otp")}`,
          type: "warn",
          duration: 5000
        });
        this.clearOtp();
        return;
      }

      const requestData = {
        email: localStorage.getItem("signup_email"),
        otp: this.otp,
      };
      const url = `${process.env.VUE_APP_API_URL}signup/verify_email_otp/`;

      try 
      
      {
        const response = await this.$store.dispatch(
            "verify_signup_email_otp",
            requestData
            );
        const token = response.data.token;
        const currentUrl = window.location.href;

        Cookies.set("auth_token", token, { expires: 7, secure: true });

        this.$emit("otpVerified", { otp: this.otp });
       if (currentUrl.includes("withdraw-funds")) {
        this.$notify({
          group: "foo",
          text: `${this.$t("otp-verified-successfully")}`,
          type: "success",
          duration: 2000
        });
        //BR#93 end
      } else {
        this.$notify({
          group: "foo",
          text: `${this.$t("otp-verified-successfully")}`,
          type: "success",
          duration: 5000
        });
      }
      } catch (error) {
        const err_msg = error?.data?.status
        console.log("err_msg = ", error)
        console.log("err_msg = ", err_msg)
        const translatedError = this.sanitizeText(err_msg);
        this.$notify({
          group: "foo",
          text: translatedError,
          type: "warn",
          duration: 5000,
        });
        this.clearOtp();
      }
    },
     sanitizeText(text) {
      const translations = {
        "Invalid OTP": this.$t("invalid-otp"),
        "Too many OTP requests. Try again later.": this.$t("too-many-otp-requests-try-again-later"),
        "Maximum limit reached. Please request for a new OTP after one minute.": this.$t("maximum-limit-reached-please-request-for-a-new-otp-after-one-minute"),
        "Maximum verification attempts exceeded. Request a new OTP.": this.$t("maximum-verification-attempts-exceeded-request-a-new-otp")
      };

      return translations[text] || text;
    },

    closeModal() {
      this.clearOtp();
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.otp-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-container {
  position: relative;
  background: #f0f8ff;
  padding: 25px;
  border-radius: 10px;
  text-align: center;
  width: 350px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

h2 {
  color: #007bff;
  margin-bottom: 10px;
}

input {
  width: 90%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #007bff;
  border-radius: 5px;
  text-align: center;
  font-size: 18px;
}

.verify-btn {
  width: 90%;
  padding: 15px;
  margin-top: 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.verify-btn:hover {
  background: #0056b3;
}

.bottom-buttons {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.cancel-btn:hover {
  background: rgb(7, 22, 233);
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  font-size: 30px;
  color: #ff0000;
  cursor: pointer;
}

.close-btn:hover {
  color: #0056b3;
}
</style>
